import { render } from "./PageClassSearch.vue?vue&type=template&id=5820ac12"
import script from "./PageClassSearch.vue?vue&type=script&lang=js"
export * from "./PageClassSearch.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__